export function calculateStats(distribution) {
  const rates = distribution.map((d) => d.rate);
  const acres = distribution.map((d) => d.acres);
  const totalAcres = acres.reduce((sum, n) => sum + n, 0);
  const weightedRates = rates.map((r, i) => r * acres[i]);
  const min = rates.length ? Math.min(...rates) : 0;
  const max = rates.length ? Math.max(...rates) : 0;
  const avg = rates.length
    ? weightedRates.reduce((sum, n) => sum + n, 0) / totalAcres
    : 0;
  const total = avg * totalAcres;

  return {
    min,
    max,
    avg,
    total,
    acres: totalAcres,
  };
}
